import { useTranslation } from "react-i18next";
import { useDispatch } from "src/store";

import { showDetails } from "@dashboard/devices/store";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";

import { Rollout } from "../../types";

type Props = {
    id: number;
    status: Rollout["status"];
};

export const RolloutStatusCell = ({ id, status }: Props) => {
    const { t } = useTranslation(["common"]);
    const dispatch = useDispatch();

    const onRollout = () => {
        dispatch(showDetails({ type: "rollout", selectedId: id }));
    };

    const getStatusLabel = () => {
        switch (status) {
            case "active":
                return t("common:status.active");
            case "completed":
                return t("common:status.completed");
            case "cancelled":
                return t("common:status.cancelled");
        }
    };

    return <MinimalTableCell onClick={onRollout}>{getStatusLabel()}</MinimalTableCell>;
};
